export default function Range({
	update,
	...props
}: {
	update: (value: number) => void;
} & React.InputHTMLAttributes<HTMLInputElement>) {
	return (
		<input
			type="range"
			{...props}
			onChange={(event) => update(Number(event.target.value))}
			className=""
		/>
	);
}
